import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import UploadIndex from './UploadIndex';

import {
    Box, Paper, Typography, Container, Divider, Button, CircularProgress, Dialog,
    DialogTitle, DialogContent, DialogActions, FormControl, TextField
} from '@mui/material';

import CustomMessage from '../../utils/components/CustomMessage';

const ImageViewer = () => {

    const auth = useSelector((state) => state.auth);
    let navigate = useNavigate();

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true);

    const [currentImg, setCurrentImg] = useState({ fileName: 'example.jpg' })
    const [open, setOpen] = useState(false);

    const [viewImage, setViewImage] = useState(false);
    const [replaceImage, setReplaceImage] = useState(false);

    const [search, setSearch] = useState('');

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    const apiUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_IMAGES_PATH : process.env.REACT_APP_DEV_IMAGES_PATH;

    useEffect(() => {
        if (!['Admin', 'Almacen', 'Secretaria', 'Vendedor', 'Ayudante'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Gestión de imágenes';
    }, [auth])

    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } });
    }

    const getData = async () => {
        setLoading(true)
        try {
            const res = await axios.get('api/images');
            if (res.status === 200) {
                setData(res.data)
                setLoading(false)
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    useEffect(() => {
        getData();
    }, [])

    const handleButton = (link) => {
        navigator.clipboard.writeText(link);
        setApiRes(state => { return { ...state, show: true, message: 'Link copiado al portapapeles', severity: 'success' } });
    }

    const handleDelete = async (img) => {
        if (!['Admin', 'Ayudante', 'Almacen'].includes(auth.user.rol)) return;
        try {
            const res = await axios.delete(`api/images/${img._id}`);
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Imagen eliminada', severity: 'success' } });
                handleClose();
                getData();
            }
        } catch (error) {
            console.log(error)
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al eliminar la imagen', severity: 'error' } });
        }
    }

    const renderImages = () => {
        if (loading) {
            return (
                <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </Container>
            )
        } else {
            return (
                <Box style={{ display: 'flex', margin: '8px', flexDirection: 'row', flexWrap: 'wrap' }}>
                    <Divider style={{ marginBottom: '10px' }} />
                    <FormControl fullWidth style={{ marginBottom: '10px' }}>
                        <TextField
                            id="search"
                            label="Buscar imagen"
                            variant="outlined"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </FormControl>
                    {
                        data.filter((item) => {
                            if (search === '') {
                                return item;
                            } else if (item.fileName.toLowerCase().includes(search.toLowerCase())) {
                                return item;
                            }
                        }).map((img) => {
                            return (
                                <Paper elevation={3} key={img._id} style={{ width: '300px', display: 'flex', margin: '8px', flexDirection: 'column', justifyContent: 'start', alignItems: 'center', padding: '24px' }}>
                                    <Typography variant='body2'>{img.fileName}</Typography>
                                    <LazyLoadImage style={{ maxWidth: '100%', maxHeight: '300px', borderRadius: '20px', boxShadow: '2px 2px 5px #888899bb' }} src={`./${img.filePath}`} alt="img" />
                                    <Typography variant='body2' style={{ margin: '8px 0px 0px 0px' }}>{(img.size / 1024).toFixed(2)} kb</Typography>
                                    <Divider variant="middle" style={{ width: '100%', margin: '8px 0px 16px 0px' }} />
                                    <Button variant='outlined' color='primary' style={{ margin: '0px 0px 8px 0px' }} onClick={() => handleOpenView(img)}>Ver Imagen &nbsp;<i className='fad fa-image'></i></Button>
                                    <Button variant='outlined' color='success' style={{ margin: '0px 0px 8px 0px' }} onClick={() => handleButton(`${apiUrl}/${img.filePath}`)}>Copiar Link &nbsp;<i className='fad fa-copy'></i></Button>
                                    <Button variant='outlined' color='secondary' style={{ margin: '0px 0px 8px 0px' }} onClick={() => handleReplace(img)}>Reemplazar Imagen &nbsp;<i className='fad fa-exchange'></i></Button>
                                    <Button disabled={!['Admin', 'Ayudante', 'Almacen'].includes(auth.user.rol)} variant='outlined' color='error' onClick={() => handleOpen(img)}>eliminar imagen &nbsp;<i className='fad fa-trash'></i></Button>
                                </Paper>
                            )
                        })
                    }
                </Box>
            )
        }
    }

    const handleOpen = (img) => {
        setCurrentImg(img)
        setOpen(true)
    }

    const handleClose = () => {
        setCurrentImg({ fileName: 'example.jpg' })
        setOpen(false)
    }

    const renderDeleteImage = () => {
        return (
            <Dialog
                open={open}
                onClose={() => handleClose()}
                fullWidth={true}
                maxWidth={'md'}
                scroll='paper'
            >
                <DialogTitle >Eliminar imagen</DialogTitle>
                <DialogContent>
                    <Typography variant='body1'>¿Estás seguro que deseas eliminar la imagen?</Typography>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '6px 0px' }}>
                        <LazyLoadImage style={{ maxWidth: '100%', borderRadius: '20px', boxShadow: '2px 2px 5px #888899bb' }} src={`./${currentImg.filePath}`} alt="img" />
                        <Typography variant='body2' style={{ margin: '8px 0px 0px 0px' }}>{`${currentImg.fileName} (${(currentImg.size / 1024).toFixed(2)} kB)`}</Typography>
                        <Button style={{ marginTop: '6px' }} variant='contained' color='error' onClick={() => handleDelete(currentImg)}>eliminar imagen &nbsp;<i className='fad fa-trash'></i></Button>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleClose()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleOpenView = (img) => {
        setCurrentImg(img)
        setViewImage(true)
    }

    const handleCloseView = () => {
        setCurrentImg({ fileName: 'example.jpg' })
        setViewImage(false)
    }

    const renderViewImage = () => {
        return (
            <Dialog
                open={viewImage}
                onClose={() => handleCloseView()}
                fullWidth={true}
                maxWidth={'md'}
                scroll='paper'
            >
                <DialogTitle >Imágen</DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '6px 0px' }}>
                        <LazyLoadImage style={{ maxWidth: '100%', borderRadius: '20px', boxShadow: '2px 2px 5px #888899bb' }} src={`./${currentImg.filePath}`} alt="img" />
                        <Typography variant='body2' style={{ margin: '8px 0px 0px 0px' }}>{`${currentImg.fileName} (${(currentImg.size / 1024).toFixed(2)} kB)`}</Typography>
                        <Button style={{ marginTop: '6px' }} variant='contained' color='success' onClick={() => handleButton(`${apiUrl}/${currentImg.filePath}`)}>Copiar Link &nbsp;<i className='fad fa-copy'></i></Button>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseView()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    const handleReplace = (img) => {
        setCurrentImg(img)
        setReplaceImage(true)
    }

    const handleCloseReplace = () => {
        setCurrentImg({ fileName: 'example.jpg' })
        setReplaceImage(false)
    }

    const renderReplaceImage = () => {
        return (
            <Dialog
                open={replaceImage}
                onClose={() => handleCloseReplace()}
                fullWidth={true}
                maxWidth={'md'}
                scroll='paper'
            >
                <DialogTitle >Reemplazar imagen</DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '6px 0px' }}>
                        <LazyLoadImage style={{ maxWidth: '25%', borderRadius: '20px', boxShadow: '2px 2px 5px #888899bb' }} src={`./${currentImg.filePath}`} alt="img" />
                        <Typography variant='body2' style={{ margin: '8px 0px 0px 0px' }}>{`${currentImg.fileName} (${(currentImg.size / 1024).toFixed(2)} kB)`}</Typography>
                        <Box>
                            <UploadIndex flag={true} id={currentImg._id} ext={`.${currentImg.fileName.split('.').pop()}`} />
                        </Box>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button color='warning' variant='contained' onClick={() => handleCloseReplace()}>Cerrar &nbsp; <i className="fad fa-times"></i></Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <>
            {renderImages()}
            {renderDeleteImage()}
            {renderViewImage()}
            {renderReplaceImage()}
            <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
        </>
    )
}

export default ImageViewer